import React from 'react';
import { SelectionState } from '../components/CustomSelection/SelectionStream';
import { Contents, Section } from '../types/epubs';

export const TextSelectionContext = React.createContext<{
  setCustomTextSelection: (customTextSelection: boolean) => void;
  setSelectionState: (selectionState: SelectionState | undefined) => void;
  setPageNumber: (pageNumber: number) => void;
  setEpubSection: (section: Section) => void;
  setEpubContents: (contents: Contents) => void;
  setContainerElement: (textLayer: HTMLDivElement) => void;
  selectionState: SelectionState;
  pageNumber: number;
  epubSection: Section;
  epubContents: Contents;
  containerElement: HTMLDivElement;
  customTextSelection: boolean;
}>({
  setCustomTextSelection: undefined,
  setSelectionState: undefined,
  setPageNumber: undefined,
  setEpubSection: undefined,
  setEpubContents: undefined,
  setContainerElement: undefined,
  selectionState: undefined,
  pageNumber: 0,
  epubSection: undefined,
  epubContents: undefined,
  containerElement: undefined,
  customTextSelection: false,
});
